import type { RouteLocationNormalized, RouteLocationRaw } from "vue-router";
import { useEplexAccountInfoStore } from "../store/eplex/eplexAccountInfo";

const BILLING_SEGMENT = "/billing";

function isBillingRoute(to: RouteLocationNormalized): boolean {
  return to.path.startsWith("/app/") && to.path.endsWith(BILLING_SEGMENT);
}

/**
 * Раздел «Биллинг» существует только для клиента на токеновом биллинге (CAB-733).
 * Кнопки в сайдбаре у остальных нет, но адрес можно набрать руками или открыть
 * из старой закладки — тогда уводим на стартовую страницу, как это делает гард
 * отключённых модулей.
 *
 * Гард асинхронный: при заходе сразу по адресу раздела сведения об учётной записи
 * ещё не загружены, и решать по пустому стору нельзя — он скрыл бы раздел
 * настоящему плательщику.
 */
export async function resolveBillingNavigation(to: RouteLocationNormalized): Promise<RouteLocationRaw | true> {
  if (!isBillingRoute(to)) return true;

  const accountInfoStore = useEplexAccountInfoStore();
  await accountInfoStore.load();

  return accountInfoStore.hasTokenBilling ? true : "/";
}
